//src/hooks/useListPublicShare.ts
import useShareStore from "src/store/api/useShareStore";

 
export const useFetchPublicShare = () => {
  const { successMessage, isLoading, error, publicSharedItem, fetchPublicShare } = useShareStore();
   return { successMessage, isLoading, error, publicSharedItem, fetchPublicShare };
};
 